import React from 'react';
import { YesNo } from '@uplift/types';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { PillRadioButtonGroup, PillRadioButtonGroupProps, PillRadioButtonGroupRaw, PillRadioButtonGroupRawProps } from './PillRadioButtonGroup.component';
import { PillRadioButton, PillRadioButtonProps } from './PillRadioButton';

export type YesNoRadioButtonGroupProps = Omit<PillRadioButtonGroupProps, 'children'> & {
  asBoolean?: boolean;
  size?: PillRadioButtonProps['size'];
};

const getYesNoMapper = (asBoolean?: boolean) => {
  if (asBoolean) {
    return {
      [YesNo.Yes]: true,
      [YesNo.No]: false,
    };
  }
  return {
    [YesNo.Yes]: YesNo.Yes,
    [YesNo.No]: YesNo.No,
  };
};

export const YesNoRadioButtonGroup: React.VFC<YesNoRadioButtonGroupProps> = ({ asBoolean, size, ...props }) => {
  const mapper = React.useMemo(() => getYesNoMapper(asBoolean), [ asBoolean ]);

  return (
    <PillRadioButtonGroup {...props}>
      <PillRadioButton size={size} label={YesNo.Yes} value={mapper[YesNo.Yes]} icon={<CheckCircle />} />
      <PillRadioButton size={size} label={YesNo.No} value={mapper[YesNo.No]} icon={<Cancel />} />
    </PillRadioButtonGroup>
  );
};

export type YesNoRadioButtonGroupRawProps = Omit<PillRadioButtonGroupRawProps, 'children' | 'value'> & {
  size?: PillRadioButtonProps['size'];
} & ({
  asBoolean: true;
  value: boolean;
} | {
  asBoolean?: never;
  value: YesNo;
});

export const YesNoRadioButtonGroupRaw: React.VFC<YesNoRadioButtonGroupRawProps> = ({ size, asBoolean, ...pillRadioButtonGroupProps }) => {
  const mapper = React.useMemo(() => getYesNoMapper(asBoolean), [ asBoolean ]);

  return (
    <PillRadioButtonGroupRaw {...pillRadioButtonGroupProps}>
      <PillRadioButton size={size} label={YesNo.Yes} value={mapper[YesNo.Yes]} icon={<CheckCircle />} />
      <PillRadioButton size={size} label={YesNo.No} value={mapper[YesNo.No]} icon={<Cancel />} />
    </PillRadioButtonGroupRaw>
  );
};
